<template>
  <div v-if="developerEnabled">
    <div class="config-panel">
      <div class="tools-title">
        <span v-on:click="expanded=!expanded">
          Developer Tools
        </span>
        |
        <span
          class="option"
          :class="{'active-off':isAnyEnable,'active-on':!isAnyEnable}"
          v-on:click="toggleDebug"
        >
          All
        </span>
      </div>
      <div v-if="expanded">
        <div class="property">
          <div class="property-item property-name">Show Permissions</div>
          <div class="property-item property-status">
          <span
            class="option"
            :class="{'active-off':!showPermissions,'active-on':showPermissions}"
            v-on:click="toggleShowPermissions"
          >
            {{ showPermissions ? 'On' : 'Off' }}
          </span>
          </div>
        </div>
        <div class="property">
          <div class="property-item property-name">Debug Mode API</div>
          <div class="property-item property-status">
          <span
            class="option"
            :class="{'active-off':!debugApi,'active-on':debugApi}"
            v-on:click="toggleDebugApi"
          >
            {{ debugApi ? 'On' : 'Off' }}
          </span>
          </div>
        </div>
        <div class="property">
          <div class="property-item property-name">Show API Requests</div>
          <div class="property-item property-status">
          <span
            class="option"
            :class="{'active-off':!showRequests,'active-on':showRequests}"
            v-on:click="toggleShowRequests"
          >
            {{ showRequests ? 'On' : 'Off' }}
          </span>
          </div>
        </div>
        <div class="property">
          <div class="property-item property-name">Show API Responses</div>
          <div class="property-item property-status">
          <span
            class="option"
            :class="{'active-off':!showResponses,'active-on':showResponses}"
            v-on:click="toggleShowResponses"
          >
            {{ showRequests ? 'On' : 'Off' }}
          </span>
          </div>
        </div>
        <div class="property">
          <div class="property-item property-name log-level-name">Log Level</div>
          <div class="property-item property-status log-level-status">
          <span
            class="option disable-select"
            :class="{'active-on':logLevel === 'debug','text-muted': logLevel !== 'debug'}"
            v-on:click="setLogLevel('debug')"
          >
            Debug
          </span> |
            <span
              class="option disable-select"
              :class="{'active-on':logLevel === 'info','text-muted': logLevel !== 'info'}"
              v-on:click="setLogLevel('info')"
            >
              Info
            </span> |
            <span
              class="option disable-select"
              :class="{'active-off':logLevel === 'error','text-muted': logLevel !== 'error'}"
              v-on:click="setLogLevel('error')"
            >
              Error
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowCircleLeft, faArrowCircleRight
} from '@fortawesome/free-solid-svg-icons';

library.add(faArrowCircleLeft, faArrowCircleRight);

export default {
  name: 'DeveloperMode',
  data() {
    return {};
  },
  computed: {
    ...mapGetters('DeveloperMode',
      [
        'developerEnabled',
        'expanded',
        'debugApi',
        'showPermissions',
        'showRequests',
        'showResponses',
        'logLevel'
      ]),
    isAnyEnable() {
      return this.debugApi || this.showRequests || this.showResponses;
    }
  },
  methods: {
    ...mapActions('DeveloperMode', [
      'toggleDeveloperMode',
      'toggleDebugApi',
      'toggleShowPermissions',
      'toggleShowRequests',
      'toggleShowResponses',
      'setShowResponses',
      'setShowRequests',
      'setDebugApi',
      'setLogLevel'
    ]),
    toggleDebug() {
      const active = !this.isAnyEnable;
      this.setDebugApi(active);
      this.setShowRequests(active);
      this.setShowResponses(active);
    },
    handler(e) {
      if (e.which === 68 && e.ctrlKey) { // control+d
        this.toggleDeveloperMode();
      }
    }
  },
  created() {
    window.addEventListener('keyup', this.handler);
  },
  mounted() {

  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handler);
  }
};
</script>

<style scoped>
.config-panel, .developer-mode {
  display: block !important;
  position: fixed;
  background-color: #1b2337;
  border: solid 1px white;
  color: white;
  z-index: 1001;
  cursor: pointer;
  font-size: 12px;
  padding: 3px;
}

.config-panel {
  top: 10px;
  width: 200px;
  vertical-align: top;
  right: 10px;
  border-radius: 15px;
  font-size: 10px;
  padding: 10px;
}

.developer-mode {
  border-radius: 5px;
  width: 140px;
  top: 10px;
  right: 10px;
}

.active, .inactive {
  float: right;
}

.active, .active-on {
  color: #00cc69;
  text-shadow: 0px 0px 3px #00cc69;
}

.tools-title {
  font-size: 13px;
  text-align: center;
  width: 100%;
  margin-bottom: 4px;
  padding-bottom: 4px;
  border-bottom: dashed 1px white;
}

.active-off {
  color: #aa0000;
  text-shadow: 0px 0px 3px #aa0000;
}

.disable-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.property-item {
  display: inline-block;
}

.property-name {
  width: 120px;
}

.property-status {
  width: 57px;
  text-align: right;
}

.log-level-name {
  width: 60px;
}

.log-level-status {
  width: 117px;
}

.option {
  cursor: pointer;
}
</style>
